import { render, staticRenderFns } from "./LeftBarProject.vue?vue&type=template&id=a3ec269e&scoped=true"
import script from "./LeftBarProject.vue?vue&type=script&lang=js"
export * from "./LeftBarProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ec269e",
  null
  
)

export default component.exports